module.exports = __webpack_public_path__ + "static/img/much-more@3x.e3ed259a.png";